import { render, staticRenderFns } from "./MemberEmptyDefaultLayout.vue?vue&type=template&id=44fb15a0&scoped=true&"
import script from "./MemberEmptyDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./MemberEmptyDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fb15a0",
  null
  
)

export default component.exports